import { useForm } from "react-hook-form";

export default function WaitlistEdit({
  initialName,
  initialEmail,
  initialPhone,
  initialRegion,
  initialDetails,
  initialIsContacted,
  onSubmit,
}) {
  // Initialize the form with default values
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: initialName,
      email: initialEmail,
      phone: initialPhone,
      region: initialRegion,
      details: initialDetails,
      isContacted: initialIsContacted,
    },
  });

  const submitForm = (data) => {
    onSubmit(data);
  };

  return (
    <form onSubmit={handleSubmit(submitForm)} className="space-y-4 p-2">
      <div className="space-y-2">
        <label htmlFor="name" className="form-label">
          Name
        </label>
        <input
          type="text"
          id="name"
          {...register("name", { required: true })}
          placeholder="Enter name"
          className="form-input border border-mediumgray"
        />
        {errors.name && (
          <p className="text-red-600 text-sm">Name is required</p>
        )}
      </div>

      <div className="space-y-2">
        <label htmlFor="email" className="form-label">
          Email
        </label>
        <input
          type="email"
          id="email"
          {...register("email", { required: true })}
          placeholder="Enter email"
          className="form-input border border-mediumgray"
        />
        {errors.email && (
          <p className="text-red-600 text-sm">Email is required</p>
        )}
      </div>
      <div className="space-y-2">
        <label htmlFor="phone" className="form-label">
          Phone
        </label>
        <input
          type="tel"
          id="phone"
          {...register("phone", { required: true })}
          placeholder="Enter phone"
          className="form-input border border-mediumgray"
        />
        {errors.phone && (
          <p className="text-red-600 text-sm">Phone is required</p>
        )}
      </div>
      <div className="space-y-2">
        <label htmlFor="region" className="form-label">
          Region
        </label>
        <input
          type="text"
          id="region"
          {...register("region", { required: true })}
          placeholder="Enter region"
          className="form-input border border-mediumgray"
        />
        {errors.region && (
          <p className="text-red-600 text-sm">Region is required</p>
        )}
      </div>
      <div className="space-y-2">
        <label htmlFor="details" className="form-label">
          Details
        </label>
        <textarea
          id="details"
          {...register("details")}
          placeholder="Enter details"
          rows={4}
          className="form-textarea border border-mediumgray"
        />
      </div>

      <div className="space-y-2">
        <label className="flex items-center gap-2 cursor-pointer ">
          <input
            type="checkbox"
            {...register("isContacted")}
            className="form-checkbox"
          />
          <span>Contacted</span>
        </label>
      </div>

      <button
        type="submit"
        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        Save
      </button>
    </form>
  );
}
